import UserActions from './components/UserActions'

export default function () {
  return { component: UserActions }
}
